import { WalletCardSignedUrl } from "./walletCardSignedUrl.tsx";
import { WalletCardLegacy } from "./walletCardLegacy.tsx";

interface WalletCardProps {
  walletQrCodeImage?: string;
  appleWalletEnabled?: boolean;
  googleWalletEnabled?: boolean;
  qrSignedUrlEnabled?: boolean;
}

/**
 * Dispatcher between the new CON-1224 signed-URL tile and the legacy tile.
 * Once WALLET_QR_SIGNED_URL is rolled out to production, the legacy branch
 * (and walletCardLegacy.tsx) will be deleted in a follow-up MR.
 */
export function WalletCard(props: WalletCardProps) {
  if (props.qrSignedUrlEnabled) {
    return (
      <WalletCardSignedUrl
        appleWalletEnabled={props.appleWalletEnabled}
        googleWalletEnabled={props.googleWalletEnabled}
      />
    );
  }
  return <WalletCardLegacy walletQrCodeImage={props.walletQrCodeImage} />;
}
